import React, { useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';

import { Box, ButtonBase, Divider, Grid, Typography } from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../assets/img/icon/Right.svg';
import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import SuraCard from '../../../../components/SuraCard';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../../context/vehicles/vehicles.provider';
import { getFormattedDate } from '../../../../helpers/getDate';
import { useProductNavigationStore } from '../../../../stores/Navigation/product-navigation.store';

const DOCUMENTS = [
  {
    link: '/documentation/document/product_policy/',
    title: 'Póliza',
    content: `Es el documento principal del seguro donde se detalla la cobertura.`,
    doc_type: 'policy',
    display: (vehicles: any[], status?: string, coverage?: boolean) =>
      vehicles.length < 4,
  },
  {
    link: '/documentation/document/product_payments_per_day/',
    title: 'Certificado de pagos al día',
    content: `Es el documento que certifica que estás al día con los pagos.`,
    doc_type: 'payments_per_day',
    display: (vehicles: any[], status?: string, coverage?: boolean) =>
      !!coverage,
  },
];

const Product = () => {
  const { loading, policy, getPolicyById } = useVehiclesContext();

  const { id }: any = useParams();

  const history = useHistory();

  const navigate_constants = useProductNavigationStore(
    (state) => state.constants
  );

  const setLastPageVisited = useProductNavigationStore(
    (state) => state.setLastPageVisited
  );

  setLastPageVisited(navigate_constants.POLICY_INFO);

  const lastPage = useProductNavigationStore((state) => state.lastPage);
  const clientType = useProductNavigationStore((state) => state.clientType);
  const { embed } = useAuthDataContext();

  useEffect(() => {
    getPolicyById(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigateBackFrom = useProductNavigationStore(
    (state) => state.navigateBackFrom
  );

  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  const goBack = () => {
    navigateBackFrom(navigate_constants.POLICY_INFO);
    if (!lastPage || clientType === navigate_constants.SINGLE_POLICY) {
      if (embed) window.parent.postMessage({ return: 'overview' }, '*');
      else redirectHome();
    } else {
      history.replace(`/documentation`);
    }
  };

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando pólizas'}></Loader>
      </Box>

      <SubHeader
        content={
          Object.keys(policy).length ? (
            <>
              <Typography variant="h6">
                {policy?.product?.description}
              </Typography>
            </>
          ) : null
        }
        goBack={() => goBack()}
      ></SubHeader>

      {Object.keys(policy).length ? (
        <Box my={2}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={11}>
              <Box my={2}>
                <Typography
                  variant="h6"
                  display="inline"
                  color="primary"
                  style={{ fontWeight: 'bold' }}
                >
                  {' '}
                  Póliza {policy.number}{' '}
                </Typography>
                <Typography variant="body2">
                  Vencimiento de póliza {getFormattedDate(policy.expires_at)}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={11}>
              <Divider style={{ marginTop: '5px', marginBottom: '10px' }} />
            </Grid>

            <Grid item xs={11}>
              <Grid container justify="space-between">
                <Grid item xs={4}>
                  <Box my={1}>
                    <Typography display="inline" variant="body2">
                      {' '}
                      Método de pago{' '}
                    </Typography>

                    <Typography variant="body2">
                      {' '}
                      Estado de cobranza{' '}
                    </Typography>

                    {policy?.financial?.pending?.expiration_date &&
                      policy?.financial?.coverage && (
                        <Typography variant="body2">
                          {' '}
                          Próximo vencimiento de cuota{' '}
                        </Typography>
                      )}
                  </Box>
                </Grid>

                <Grid item xs={4}>
                  <Box my={1}>
                    <Typography
                      variant="body2"
                      display="inline"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      {policy.payment_type_name}{' '}
                    </Typography>

                    {policy?.financial?.coverage && (
                      <Typography
                        variant="body2"
                        style={{ fontWeight: 'bold' }}
                      >
                        {' '}
                        Pago al día{' '}
                      </Typography>
                    )}

                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                      {policy?.financial?.pending?.expiration_date &&
                      policy?.financial?.coverage
                        ? getFormattedDate(
                            policy?.financial?.pending?.expiration_date
                          )
                        : 'No tiene vencimientos próximos'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box my={1}>
                    <Typography variant="h6"> Documentos </Typography>
                  </Box>

                  <Grid container>
                    {DOCUMENTS.map(
                      (doc: any, index: number) =>
                        doc.display(
                          policy.vehicles,
                          policy.status,
                          policy.financial.coverage
                        ) && (
                          <Grid item xs={12} sm={6} key={index}>
                            <Box
                              mr={2}
                              my={2}
                              style={{ height: 'calc(100% - 16px)' }}
                            >
                              <ButtonBase
                                component={Link}
                                to={{ pathname: doc.link }}
                                style={{ width: '100%', height: '100%' }}
                              >
                                <SuraCard>
                                  <Box
                                    m={2}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    width="100%"
                                  >
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                      alignItems="flex-start"
                                      flexDirection="column"
                                    >
                                      <Box>
                                        <Typography
                                          variant="body1"
                                          color="primary"
                                        >
                                          {' '}
                                          {doc.title}{' '}
                                        </Typography>
                                        <Typography variant="caption">
                                          {' '}
                                          {doc.content}{' '}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box>
                                      <RightIcon></RightIcon>
                                    </Box>
                                  </Box>
                                </SuraCard>
                              </ButtonBase>
                            </Box>
                          </Grid>
                        )
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      ) : null}
    </>
  );
};

export default Product;
